import { render } from "./LevelUp.vue?vue&type=template&id=351fbd18&scoped=true"
import script from "./LevelUp.vue?vue&type=script&lang=js"
export * from "./LevelUp.vue?vue&type=script&lang=js"

import "./LevelUp.vue?vue&type=style&index=0&id=351fbd18&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351fbd18"]])

export default __exports__